<template>
  <div justify="center">
    <v-dialog v-model="dialog" persistent max-width="760">
      <v-card>
        <v-card-title
          class="text-h5"
          style="background-color:#00538B; display: flex; justify-content: center; color: white; text-align: center"
          >Important
        </v-card-title>
        <v-card-text
          style="display: flex; flex-direction:column; justify-content: center; align-items: center; gap: 4px; margin-top: 17px; letter-spacing: -.3px;"
        >
          <span>
            VCGS cannot accept multiple trio orders via the online test request
            system, please remove a trio test to continue.
          </span>
          <span>
            If you are unsure, contact
            <a href="mailto:VCGSgenomics@vcgs.org.au"
              >VCGSgenomics@vcgs.org.au</a
            >
            or 03 9340 9102 for assistance.
          </span>
        </v-card-text>
        <v-card-actions style="display: flex; justify-content: center;">
          <v-btn
            style="background-color: #00538B; color: white; margin-bottom: 10px;"
            text
            @click="onContinue"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { EventBus } from "../event-bus";

export default {
  props: {
    hasMultiTrioTests: { type: Boolean, default: false },
    submittingMultiTrio: Boolean,
  },
  data() {
    return {
      dialog: this.hasMultiTrioTests,
    };
  },
  watch: {
    hasMultiTrioTests(newValue) {
      this.dialog = newValue;
    },
    submittingMultiTrio(newValue) {
      this.dialog = newValue;
    },
  },
  methods: {
    onContinue() {
      this.dialog = false;
      EventBus.$emit("handleSubmittingMultiTrio", false);
    },
  },
};
</script>
